import React, { Component } from 'react';
import './ComingSoon.scss';

class ComingSoon extends Component {
    render() {
        return (
            <div className="ComingSoon">
                <div className="ComingSoon-cube">
                    <div className="cube-face front" />
                    <div className="cube-face back" />
                    <div className="cube-face right" />
                    <div className="cube-face left" />
                    <div className="cube-face top" />
                    <div className="cube-face bottom" />
                </div>
                <div className="ComingSoon-text">
                    <h1 className="ComingSoon-title">{'En développement'}</h1>
                    <p className="ComingSoon-subtitle">{'Le site revient bientôt avec un nouveau concept.'}</p>
                </div>
            </div>
        );
    }
}

export default ComingSoon;
